// @flow

export default function omit(obj: Object, key: string | string[]): Object {
  const copy = Object.assign({}, obj);
  [].concat(key).forEach(k => {
    delete copy[k];
  });
  return copy;
}
